import React, { FC, useContext } from 'react'
import { ChatContext } from '~/service/chatConn'
import { Wrapper } from './Wrapper'
import { post } from '~/utils/api'
import { v4 as uuidv4 } from 'uuid'

type Props = {
  disabled: boolean
  aiLang: string
}

const completionType = 'autocomplete'

const ChatCompletion: FC<Props> = ({ disabled, aiLang }) => {
  const { activeChat, aiCompletionStart } = useContext(ChatContext)

  const loading = activeChat.aiCompletion?.type === completionType

  return (
    <Wrapper
      disabled={loading || disabled}
      tabIndex={0}
      tip={intl.formatMessage({
        id: 'chat / input / auto completion',
      })}
      onClick={async () => {
        const requestId = uuidv4()

        aiCompletionStart(activeChat.id, requestId, completionType)

        post(`chat/aiCompletion/${activeChat.id}`, {
          requestId,
          customUserData: activeChat.customUserData,
          aiLang,
        })
      }}
    >
      <span
        className={
          loading ? 'fa fa-spin fa-spinner-third' : 'far fa-wand-magic-sparkles'
        }
      />
    </Wrapper>
  )
}

export default ChatCompletion
